{
	"title": "Kortingscodes",
	"description": "Codes voor acties en de nieuwsbrief: een percentage, een vast bedrag of gratis verzending.",
	"searchLabel": "Zoek op code",
	"empty": "Er zijn nog geen kortingscodes.",
	"column": {
		"code": "Code",
		"discount": "Korting",
		"validity": "Geldig",
		"uses": "Gebruikt",
		"status": "Status",
		"created": "Aangemaakt"
	},
	"status": {
		"label": "Status",
		"active": "Actief",
		"scheduled": "Gepland",
		"expired": "Verlopen",
		"usedUp": "Op"
	},
	"kind": {
		"percentage": "Percentage",
		"fixedAmount": "Vast bedrag",
		"freeShipping": "Gratis verzending"
	},
	"describe": {
		"percentage": "{{percent}}% korting",
		"fixedAmount": "{{amount}} korting",
		"freeShipping": "Gratis verzending"
	},
	"validity": {
		"always": "Altijd",
		"from": "Vanaf {{start}}",
		"until": "Tot {{end}}",
		"between": "{{start}} – {{end}}"
	},
	"uses": {
		"unlimited": "{{used}}",
		"limited": "{{used}} van {{max}}"
	},
	"new": {
		"title": "Kortingscode maken",
		"description": "Een code werkt meteen, tenzij je een begin kiest. Klanten typen hem in de mand, hoofdletters maken niet uit.",
		"submit": "Maken"
	},
	"edit": {
		"submit": "Opslaan"
	},
	"section": {
		"code": "Code en korting",
		"validity": "Geldigheid",
		"validityDescription": "In Nederlandse tijd. Leeg laten: geen begin of geen einde.",
		"limits": "Voorwaarden en gebruik",
		"scope": "Beperking",
		"scopeDescription": "Niets gekozen: de code geldt voor alle producten en alle klantgroepen."
	},
	"field": {
		"code": "Code",
		"codeDescription": "Letters, cijfers, - en _. Wordt in hoofdletters bewaard.",
		"kind": "Soort korting",
		"percent": "Percentage",
		"amount": "Bedrag",
		"amountDescription": "Op het bedrag dat de klant ziet: incl. btw voor consumenten, excl. btw voor zakelijke klantgroepen.",
		"freeShippingDescription": "De verzendkosten vallen weg; de producten houden hun prijs.",
		"startsAt": "Geldig vanaf",
		"endsAt": "Geldig tot",
		"minimumOrderAmount": "Minimum orderbedrag",
		"minimumOrderAmountDescription": "Het bedrag aan producten vóór korting, zonder verzendkosten. Leeg: geen minimum.",
		"maxUses": "Maximaal gebruik, totaal",
		"maxUsesPerCustomer": "Maximaal gebruik per klant",
		"maxUsesDescription": "Leeg: onbeperkt.",
		"customerGroups": "Klantgroepen",
		"products": "Producten",
		"productSearch": "Zoek een product om toe te voegen",
		"productNone": "Geen producten gevonden.",
		"productAdd": "{{name}} toevoegen",
		"productRemove": "{{name}} weghalen",
		"allProducts": "Alle producten",
		"allCustomerGroups": "Alle klantgroepen"
	},
	"facts": {
		"title": "Overzicht",
		"status": "Status",
		"uses": "Gebruikt",
		"created": "Aangemaakt",
		"updated": "Laatst opgeslagen"
	},
	"taken": "Deze code bestaat al.",
	"scopeGone": "Een gekozen product of klantgroep bestaat niet meer. Laad de pagina opnieuw.",
	"maxUsesBelowUsed_one": "De code is al {{count}} keer gebruikt; het maximum kan niet lager.",
	"maxUsesBelowUsed_other": "De code is al {{count}} keer gebruikt; het maximum kan niet lager.",
	"changed": "Iemand anders heeft deze code intussen opgeslagen. Laad hem opnieuw; je wijzigingen gaan dan verloren.",
	"reload": "Opnieuw laden",
	"delete": {
		"button": "Verwijderen",
		"title": "Kortingscode verwijderen?",
		"description": "{{code}} werkt daarna niet meer. Dit kun je niet ongedaan maken.",
		"confirm": "Verwijderen",
		"used": "Een gebruikte code kun je niet verwijderen: de orders verwijzen ernaar. Zet een einddatum om hem te stoppen."
	},
	"origin": {
		"label": "Herkomst",
		"manual": "Zelf gemaakt",
		"welcome": "Welkomstcode"
	},
	"help": {
		"codes": {
			"title": "Kortingscodes",
			"area": "Kortingscodes",
			"short": "Met een kortingscode krijgt een klant korting in de mand: een percentage, een vast bedrag of gratis verzending. Per order past één code. De lijst toont elke code met zijn gebruik en status.",
			"terms": [
				"discountCode:kind",
				"discountCode:inCart",
				"discountCode:status",
				"discountCode:origin",
				"discountCode:new"
			]
		},
		"status": {
			"title": "Status",
			"area": "Kortingscodes",
			"short": "De status volgt uit de geldigheid en het gebruik; je zet hem niet zelf. Alleen een actieve code geeft korting.",
			"choices": [
				{
					"name": "Actief",
					"text": "Geldig en nog niet op: klanten kunnen hem gebruiken."
				},
				{
					"name": "Gepland",
					"text": "Het begin is nog niet bereikt."
				},
				{
					"name": "Verlopen",
					"text": "Het einde is voorbij."
				},
				{
					"name": "Op",
					"text": "Zo vaak gebruikt als het maximum in totaal toelaat."
				}
			],
			"terms": ["discountCode:validity", "discountCode:limits"]
		},
		"origin": {
			"title": "Herkomst",
			"area": "Kortingscodes",
			"short": "Een code maak je zelf, of de shop maakt hem: een welkomstcode bij een aanmelding voor de nieuwsbrief. Die herken je aan het label Welkomstcode. Verder werkt hij als elke andere code.",
			"choices": [
				{
					"name": "Zelf gemaakt",
					"text": "Gemaakt met Kortingscode maken."
				},
				{
					"name": "Welkomstcode",
					"text": "Eén per canoniek adres, één keer te gebruiken, voor alle producten, en geldig voor het aantal dagen dat bij de nieuwsbrief staat."
				}
			],
			"goTo": {
				"to": "/content/newsletter",
				"label": "Naar Nieuwsbrief"
			}
		},
		"new": {
			"title": "Kortingscode maken",
			"area": "Kortingscodes › Kortingscode maken",
			"short": "Kies de code, de soort korting en de waarde. Laat je de rest leeg, dan werkt de code meteen, onbeperkt, voor alle producten en klanten. Na Maken opent de code en kun je alles nog aanpassen.",
			"terms": [
				"discountCode:code",
				"discountCode:kind",
				"discountCode:validity",
				"discountCode:limits",
				"discountCode:scope"
			]
		},
		"edit": {
			"title": "Kortingscode bewerken",
			"area": "Kortingscodes",
			"short": "Een wijziging geldt voor elke mand vanaf nu; een geplaatste order houdt zijn korting. Bij Overzicht zie je hoe vaak de code gebruikt is.",
			"terms": [
				"discountCode:overview",
				"discountCode:kind",
				"discountCode:validity",
				"discountCode:limits",
				"discountCode:scope"
			]
		},
		"code": {
			"title": "Code",
			"area": "Kortingscodes › Code en korting",
			"short": "Wat de klant in de mand typt. Hoofdletters maken niet uit: zomer10 werkt als ZOMER10. Elke code bestaat één keer; ook een verlopen code houdt zijn naam bezet.",
			"terms": ["discountCode:inCart"]
		},
		"kind": {
			"title": "Soort korting",
			"area": "Kortingscodes › Code en korting",
			"short": "De soort bepaalt wat er van de mand afgaat: van de producten, of van de verzendkosten. Een code doet nooit allebei.",
			"choices": [
				{
					"name": "Percentage",
					"text": "Dat percentage van elk product in de mand, per regel afgerond."
				},
				{
					"name": "Vast bedrag",
					"text": "Een bedrag van de producten, nooit meer dan ze kosten. De verzendkosten blijven."
				},
				{
					"name": "Gratis verzending",
					"text": "De verzendkosten vallen weg; de producten houden hun prijs."
				}
			],
			"warning": "Een vast bedrag geldt op de prijzen die de klant ziet: incl. btw voor een consument, excl. btw voor een zakelijke klantgroep. Daar is €5 korting dus €6,05 incl. 21% btw.",
			"terms": ["discountCode:inCart", "price:customerGroup", "discountCode:scope"]
		},
		"inCart": {
			"title": "Code in de mand",
			"area": "Kortingscodes",
			"short": "De klant typt de code in de mand en klikt op Toepassen. Dan staat de korting erbij, met de code. Geldt hij niet, dan zegt de shop waarom, zoals \"Deze kortingscode is verlopen.\"",
			"warning": "Een mand heeft één code: voor een andere haalt de klant de eerste weg. Een code telt pas als gebruikt bij een geplaatste order. Gratis verzending vanaf een bedrag rekent met het bedrag na korting.",
			"terms": ["discountCode:kind", "discountCode:limits"]
		},
		"validity": {
			"title": "Geldigheid",
			"area": "Kortingscodes › Geldigheid",
			"short": "De code werkt van het begin tot het einde, in Nederlandse tijd (Amsterdam). Op het eindmoment zelf werkt hij niet meer. Zonder begin werkt hij meteen, zonder einde blijft hij werken.",
			"warning": "Heeft een klant de code al in zijn mand, dan valt de korting weg als hij na het einde afrekent.",
			"terms": ["discountCode:status"]
		},
		"limits": {
			"title": "Voorwaarden en gebruik",
			"area": "Kortingscodes › Voorwaarden en gebruik",
			"short": "Het minimum orderbedrag telt de producten vóór korting, zonder verzendkosten. Het maximale gebruik telt orders met de code, in totaal en per klant; een verlopen of geannuleerde order geeft zijn gebruik terug. Leeg is onbeperkt.",
			"warning": "Het maximum kan niet lager dan het gebruik tot nu toe. Is het totaal bereikt, dan staat de code op Op.",
			"terms": ["discountCode:perCustomer", "discountCode:status"]
		},
		"perCustomer": {
			"title": "Per klant",
			"area": "Kortingscodes › Voorwaarden en gebruik",
			"short": "Een klant met een account telt per account. Een gast telt per canoniek adres: jan+actie@gmail.com en j.an@gmail.com zijn dan één gast. Een andere schrijfwijze van hetzelfde adres geeft dus geen extra gebruik.",
			"terms": ["discountCode:limits"]
		},
		"scope": {
			"title": "Beperking",
			"area": "Kortingscodes › Beperking",
			"short": "Kies je producten, dan gaat de korting alleen van die producten af. Kies je klantgroepen, dan werkt de code alleen voor klanten in die groepen. Kies je niets, dan geldt hij overal.",
			"warning": "Een product met een klantprijs krijgt nooit korting van een code. Staat er geen product uit de beperking in de mand, dan zegt de shop dat de code niet geldt.",
			"terms": ["discountCode:products", "price:customerGroup", "customer:customerPrice"]
		},
		"products": {
			"title": "Producten in de beperking",
			"area": "Kortingscodes › Beperking",
			"short": "Zoek op naam of SKU en voeg het product toe; de code geldt dan voor al zijn varianten. Een gearchiveerd product blijft in de lijst staan, maar is niet meer te koop.",
			"warning": "Verwijder je een product dat in een code staat, dan wordt het gearchiveerd. Staan er alleen nog gearchiveerde producten in, dan geldt de code voor niets meer.",
			"terms": ["product:delete", "discountCode:scope"]
		},
		"overview": {
			"title": "Overzicht",
			"area": "Kortingscodes",
			"short": "Gebruikt telt de orders met deze code, met het maximum erachter; een verlopen of geannuleerde order telt niet mee. Staat Gebruikt op 0, dan kun je de code verwijderen.",
			"warning": "Een gebruikte code kun je niet verwijderen: de orders verwijzen ernaar. Stop hem met een einddatum.",
			"terms": ["discountCode:validity", "discountCode:status"]
		}
	},
	"helpExample": {
		"sandbox": "Kies de soort en de waarde, en zie wat er van de voorbeeldmand afgaat.",
		"cart": "Voorbeeldmand: 2 × Floorwipes XXL, 20 doekjes (€8,95) en 1 × 60 doekjes (€19,95), verzonden naar Nederland.",
		"kind": "Soort korting",
		"percent": "Percentage",
		"amount": "Bedrag",
		"less": "Minder",
		"more": "Meer",
		"code": {
			"percentage": "ZOMER{{percent}}",
			"fixedAmount": "CADEAU",
			"freeShipping": "GRATISVERZENDEN"
		},
		"effect": {
			"discount": "Korting",
			"shippingPaid": "Verzendkosten voor de klant",
			"toPay": "Te betalen"
		},
		"shopLabel": "De mand in de shop met code {{code}}: {{applied}} Subtotaal {{goods}}, korting {{discount}}, verzenden {{shipping}}, totaal {{toPay}}.",
		"live": "Korting {{discount}}, verzendkosten voor de klant {{shipping}}, te betalen {{toPay}}.",
		"new": {
			"steps": {
				"code": "Typ de code: ZOMER10",
				"kind": "Kies de soort: Percentage",
				"value": "Typ het percentage: 10",
				"save": "Klik op Maken",
				"shop": "In de mand: ZOMER10 toegepast"
			},
			"animation": "Animatie: je typt de code ZOMER10, kiest de soort Percentage, typt 10 en klikt op Maken. In de mand van de shop staat daarna: ZOMER10 toegepast: €3,79 korting.",
			"code": "ZOMER10"
		}
	}
}
